import { useAppSelector } from '@/shared/hooks/useStore';
import { selectCurrentProject } from '@/viewmodel/features/project';
import { createContext, useContext } from 'react';

export interface SourceProject {
  readonly projectId: string;
  readonly requestId: string;
}

export const SourceProjectContext = createContext<SourceProject | null>(null);

export function useSourceProject(): SourceProject {
  const scoped = useContext(SourceProjectContext);
  const current = useAppSelector(selectCurrentProject);

  return scoped ?? { projectId: current?.id ?? '', requestId: current?.request_id ?? '' };
}
